import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p>
          © 2025 Mutu Nde Espoir ASBL - By Laurent KOMPANI et Faysal BAONGA - tEAM Dev. +243 85 36 35 877 - Tous droits réservés.
        </p>
      </div>
    </footer>
  );
};

export default Footer;

